<template>
	<div class="style-one" style="max-width: 1280px; margin: auto;">
		<h1 class="style-title">
			<img class="title-icon" :src="icon" v-if="icon!=null" />
			{{title}}
			<a class="more" target="_blank" href="#!" v-if="more" @click.prevent="onmore()"> 更多
				<svg class="icon hover-icon" viewBox="0 0 1024 1024">
					<path
						d="M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z m-18.432 306.261333a42.666667 42.666667 0 0 0-48.469333 0l-5.973334 4.864-4.864 5.973334a42.666667 42.666667 0 0 0 0 48.469333l4.864 5.973333L579.669333 512 439.125333 652.458667l-4.864 5.973333a42.666667 42.666667 0 0 0 59.306667 59.306667l5.973333-4.864L700.330667 512 499.541333 311.125333l-5.973333-4.864z">
					</path>1
				</svg>
			</a>
		</h1>
		<ul>
			<vue-virtual-item v-for="(item,index) in list" :title="item.title" :img="item.img" :label1="item.label1"
				:label2="item.label2" :url="'/home/product-details/'+item.id" :margin_right_0="(index+1)%5==0"
				:itemStyle="itemStyle"></vue-virtual-item>
		</ul>
	</div>

</template>

<script>
	import vueVirtualItem from '@/components/vue-virtual-item'
	export default {
		props: {
			title: {
				type: String
			},
			more: {
				type: Boolean,
				default: true
			},
			icon: {
				type: String
			},
			list: {
				type: Array
			},
			itemStyle: {
				type: Object,
				default () {
					return {}
				}
			}
		},
		data() {
			return {}
		},
		methods: {
			onmore() {
				this.$emit('onmore')
			}
		},
		components: {
			vueVirtualItem
		}
	}
</script>

<style scoped>
	.style-one {
		overflow: hidden;
		clear: both;


	}

	.style-one ul {
		margin: 0;
		padding: 0;
		overflow: hidden;
		zoom: 1;
		height: 100%;
	}

	.style-title {
		font-size: 30px;
		color: #2A2A2A;
		line-height: 42px;
		font-weight: 500;
		color: #2A2A2A;


	}

	.style-title .icon {
		width: 13px;
		height: 13px;
		position: absolute;
		top: 7px;
		margin-left: 4px;
		fill: #777;
	}

	.style-title .title-icon {
		width: 30px;
		height: 30px;
		float: left;
		margin-right: 10px;
		margin-top: 8px;
	}

	.style-title .block-type {
		display: none;
	}

	.style-title .light-type {
		display: inline-block;
	}

	.style-title .more {
		border: 1px solid #EDEDED;
		color: #777;
		text-decoration: none !important;
		outline: none;
		display: inline-block;
		margin-left: 30px;
		border-radius: 16px;
		font-size: 14px;
		height: 28px;
		width: 63px;
		padding-left: 10px;
		box-sizing: border-box;
		line-height: 27px;
		cursor: pointer;
		position: relative;
	}

	.style-title .more:hover {
		color: rgb(61, 132, 255);
		border: 1px solid rgb(61, 132, 255);

		svg {
			fill: rgb(61, 132, 255)
		}
	}
</style>
